import clsx from "clsx";
import React, { memo } from "react";
import { Handle, ReactFlowProvider } from "react-flow-renderer";
import { useSelector } from "react-redux";

import "./index.css";

const CustomNode = (node) => {
  const graph = useSelector((state) => {
    const { activeGraphId } = state.ui;
    if (activeGraphId === 1) {
      return state.v1Graph;
    } else if (activeGraphId === 2) {
      return state.v2Graph;
    } else {
      return state.v3Graph;
    }
  });

  const isSource = graph.sourceNodeId === node.id;
  const isDestination = graph.destinationNodeId === node.id;
  const isVisited = node.data.shortestPath !== undefined;

  return (
    <ReactFlowProvider>
      <div
        className={clsx(
          "node",
          isDestination && "destination",
          isSource && "source",
          isVisited && "visited"
        )}
      >
        <div className="label">{node.id}</div>
        {node.data.shortestPath !== undefined && (
          <div className="shortest-path">{node.data.shortestPath}</div>
        )}
        <Handle position="top" id="handle-top" />
        <Handle position="left" id="handle-left" />
        <Handle position="bottom" id="handle-bottom" />
        <Handle position="right" id="handle-right" />
      </div>
    </ReactFlowProvider>
  );
};

export default CustomNode;
